<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.CustomerName"
        :secondaryLabel="model.CustomerCode"
        recordType="Customer"
        v-if="model.CustomerCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <dx-data-grid
              :data-source="dataSourceConfig"
              ref="deliveryAddressGrid"
              :columns="columns"
              :height="gridHeight - 20"
              @selection-changed="onSelectionChanged"
              @toolbar-preparing="onToolbarPreparing($event)"
              @content-ready="addGridNoResults($event)"
              v-if="model.CustomerCode"
              :selection="{ mode: 'single' }"
              @exporting="
                onGridToExcelExporting(
                  $event,
                  `Customer - ${baseView.id} - Delivery Addresses`,
                  columns
                )
              "
            >
              <DxPaging :page-size="50" :enabled="false" />
              <DxPager
                :showInfo="true"
                :showPageSizeSelector="false"
                :infoText="'({2} items)'"
                :visible="false"
              />

              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preloadEnabled="true"
              />
              <DxExport :enabled="true" />
              <template #default-cell-template="{ data }">
                <DxCheckBox
                  v-if="data.data.LineNo === 1"
                  :value="true"
                  :read-only="true"
                />
                <DxCheckBox
                  v-else-if="data.data.LineNo != 1"
                  :read-only="
                    !formsConfig.editableOption || baseView.mode != 'review'
                  "
                  @value-changed="changeDefaultAddress(data.data)"
                />
              </template>

              <template #active-cell-template="{ data }">
                <GcInactive :inactive="data.data.Inactive" />
              </template>
            </dx-data-grid>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary">{{ model.CompanyName }}</span>
              </div>
            </DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'tooblar-active-form',
                labelLocation: 'left',
              }"
              locate-in-menu="after"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <!-- <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            /> -->

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
                v-if="formLoading && showRightContainer"
                @content-ready="onFormContentReady"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";

import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { CustomerSubRegionService } from "../../_services/api/settings/customers/customer-sub-region.service";
import { CustomerRegionService } from "../../_services/api/settings/customers/customer-region.service";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import validationEngine from "devextreme/ui/validation_engine";
import { CustomerDropCodeService } from "../../_services/api/customers/customer-dropcode.service";
import { FeatureStorage } from "../../_services/storage";

export default {
  mixins: [BaseViewMixin, CustomerTabsMixin],
  created() {
    this.selectedIndex = 2;
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          tabIndex: -1,
          onClick: this.close,
        },

        edit: {
          icon: "edit",
          tabIndex: -1,
          onClick: () => {
            this.$router.push({
              path: `/customer-delivery-address/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveCustomerDeliveryAddress(e);
          },
        },

        audit: {
          icon: "clock",
          tabIndex: -1,
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      model: {
        CompanyName: "",
        PhysicalAddressCountry: "",
        CustomerCode: "",
        CustomerName: "",
        Active: true,
        Note1: "",
        Note2: "",
        PhysicalAddressPostcode: "",
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        RecordId: "00000000-0000-0000-0000-000000000000",
        LineNo: 0,
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
        SelfReference: "",
        TransitDays: 0,
        CustomerRegionCode: undefined,
        CustomerSubRegionCode: undefined,
        DeliveryInstructions: undefined,
      },
      CustomerDetails: [],
      disabletoggle: true,
      formLoading: false,
    };
  },
  computed: {
    columns() {
      return this.parseGridColumns("master", this.getColumns);
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "CompanyName",
              gcLabel: "Name",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Name is required",
                },
              ],
            },
            {
              dataField: "PhysicalAddressStreetLine1",
              gcLabel: "Street Line 1",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Street Line 1 is required",
                },
              ],
            },
            {
              dataField: "PhysicalAddressStreetLine2",
              gcLabel: "Street Line 2",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
              },
            },
            {
              dataField: "PhysicalAddressSuburb",
              gcLabel: "Suburb",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Suburb is required",
                },
              ],
            },

            {
              dataField: "PhysicalAddressState",
              gcLabel: "State",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
              validationRules: [
                {
                  type: "required",
                  message: "State is required",
                },
              ],
            },

            {
              dataField: "PhysicalAddressPostcode",
              gcLabel: "Post Code",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Post Code is required",
                },
              ],
            },

            {
              dataField: "PhysicalAddressCountry",
              gcLabel: "Country",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Country is required",
                },
              ],
            },
            {
              dataField: "DropCode",
              gcLabel: "Drop Code",
              gcType: "String",
              editorType: "dxSelectBox",
              id: "sales-rep-selectBox",
              editorOptions: {
                dataSource: CustomerRegionService.dataSourceConfig(
                  "api/DropCode",
                  {
                    select: ["Code", "Description", "Inactive"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Code", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Description}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Code}
                            </span>
                          </div>`;
                },
                // onValueChanged: (e) => {
                //   if (e.event) this.getDefaultSubRegion(e.value);
                // },
              },
              // validationRules: [
              //   {
              //     type: "required",
              //     message: "Region is required",
              //   },
              // ],
            },

            {
              dataField: "SelfReference",
              gcLabel: "Delivery Self Ref",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
              },
            },

            {
              dataField: "TransitDays",
              gcLabel: "Transit Days",
              gcType: "Decimal-9-0",
              editorOptions: {
                maxLength: 20,
              },
              required: true,
            },

            {
              dataField: "Note1",
              gcLabel: "Note 1",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },

            {
              dataField: "Note2",
              gcLabel: "Note 2",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },

            {
              dataField: "CustomerRegionCode",
              gcLabel: "Region",
              gcType: "String",
              editorType:
                this.baseView.mode == "review" ? "dxTextBox" : "dxSelectBox",
              id: "sales-rep-selectBox",
              editorOptions: {
                dataSource: CustomerRegionService.dataSourceConfig(
                  "api/CustomerRegion",
                  {
                    select: ["Code"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Code", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Code",
                searchExpr: ["Code"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                onValueChanged: (e) => {
                  if (e.event) this.getDefaultSubRegion(e.value);
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Region is required",
                },
              ],
            },

            {
              dataField: "CustomerSubRegionCode",
              gcLabel: "Sub Region",
              gcType: "String",
              editorType:
                this.baseView.mode == "review" ? "dxTextBox" : "dxSelectBox",
              id: "sales-rep-selectBox",
              editorOptions: {
                dataSource: CustomerSubRegionService.dataSourceConfig(
                  "api/CustomerSubRegion",
                  {
                    select: ["Code"],
                    filter: [
                      ["Inactive", "=", "N"],
                      "and",
                      [
                        "CustomerRegionCode",
                        "=",
                        this.model.CustomerRegionCode,
                      ],
                    ],
                    sort: [{ selector: "Code", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Code",
                searchExpr: ["Code"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                readOnly: !this.model.CustomerRegionCode,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Sub Region is required",
                },
              ],
            },
            {
              dataField: "DeliveryInstructions",
              gcLabel: "Delivery Instructions",
              gcType: "String",
              editorType: "dxTextArea",
              editorOptions: {
                maxLength: 1000,
                height: 100,
              },
            },
          ]),
        },
      ];

      return formFields;
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",

          editorOptions: {
            readOnly:
              this.baseView.mode == "review" ? true : this.disabletoggle,
            onValueChanged: (e) => {
              if (e.value == false) {
                this.getSalesOrder(e);
              }
            },
          },
        },
      ]);
    },

    dataSourceConfig() {
      return CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          // sort: [{ selector: "LineNo", desc: false }],
          filter: [["CustomerCode", "=", this.model.CustomerCode]],
          select: ["RecordId", "CustomerCode"].concat(
            this.getSelectFields(this.getColumns)
          ),
        }
      );
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    getColumns() {
      return [
        {
          gcLabel: "Name",
          dataField: "CompanyName",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },

        {
          gcLabel: "Street Line 1",
          dataField: "PhysicalAddressStreetLine1",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Street Line 2",
          dataField: "PhysicalAddressStreetLine2",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Suburb",
          dataField: "PhysicalAddressSuburb",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "State",
          dataField: "PhysicalAddressState",
          gcType: "String",
          width: 120,
        },
        {
          gcLabel: "Post Code",
          dataField: "PhysicalAddressPostcode",
          gcType: "String",
          width: 120,
        },
        {
          gcLabel: "Country",
          dataField: "PhysicalAddressCountry",
          gcType: "String",
          width: 120,
        },
        {
          gcLabel: "Delivery Self Ref",
          dataField: "SelfReference",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 120,
        },
        {
          gcLabel: "Transit Days",
          dataField: "TransitDays",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 120,
        },
        {
          gcLabel: "Note 1",
          dataField: "Note1",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 120,
        },
        {
          gcLabel: "Note 2",
          dataField: "Note2",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 120,
        },
        {
          gcLabel: "Region",
          dataField: "RegionCode",
          gcType: "String",
          // gcSubType: "HiddenDescription",
          width: 150,
        },
        {
          gcLabel: "Sub Region",
          dataField: "SubregionCode",
          gcType: "String",
          // gcSubType: "HiddenDescription",
          width: 150,
        },
        {
          gcType: "String",
          gcSubType: "Chip",
          dataField: "Inactive",
          cellTemplate: "active-cell-template",
        },
      ];
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["deliveryAddressGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    onFormContentReady(e) {
      if (e) {
        validationEngine.validateGroup(this.formsConfig.validationGroup);
        e.component.instance().getEditor("CompanyName").focus();
      }
    },
    async getSalesOrder(e) {
      var DeliveryAddressStreetLine1;
      var DeliveryAddressStreetLine2;

      await SalesOrderService.getActiveByCode(this.model.CustomerCode).then(
        (res) => {
          DeliveryAddressStreetLine1 =
            res.data.value[0].DeliveryAddressStreetLine1;
          DeliveryAddressStreetLine2 =
            res.data.value[0].DeliveryAddressStreetLine2;

          if (
            DeliveryAddressStreetLine1 ==
              this.model.PhysicalAddressStreetLine1 &&
            DeliveryAddressStreetLine2 ==
              this.model.PhysicalAddressStreetLine2 &&
            this.model.Active == false
          ) {
            this.displayValidationSummary([
              `This delivery address is assigned to an active Sales Order and cannot be made inactive`,
            ]);

            e.component.beginUpdate();
            e.component.option("value", "N");
            e.component.endUpdate();
          }
        }
      );
    },

    async getcusdetail(CustomerCode, e) {
      await CustomerDeliveryAddressService.getAllByCode(CustomerCode).then(
        (res) => {
          if (this.baseView.mode == "review") {
            this.disabletoggle = true;
          } else {
            if (res.data.value.length == 1) {
              this.disabletoggle = true;
            } else {
              var checkInactive = 0;
              res.data.value.forEach((res) => {
                if (res.Inactive == "N") {
                  checkInactive = checkInactive + 1;
                  // index = res.index +1;
                }
              });

              if (checkInactive == 1 && e == "N") {
                this.disabletoggle = true;
              } else {
                this.disabletoggle = false;
              }
            }
          }
        }
      );
      return true;
    },

    async getDefaultSubRegion(CustomerRegionCode) {
      if (CustomerRegionCode)
        await CustomerSubRegionService.getDefaultByRegion(CustomerRegionCode, {
          select: ["IsDefault", "CustomerRegionCode", "Code"],
        }).then((res) => {
          if (res.data.value.length > 0)
            this.model.CustomerSubRegionCode = res.data.value[0].Code;
        });
      else this.model.CustomerSubRegionCode = undefined;
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["deliveryAddressGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.CustomerCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-delivery-address/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["deliveryAddressGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.CustomerCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/customer-delivery-address/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/customer",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "exportButton" && item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            visible: FeatureStorage.checkPermission(
              "CustomerDeliveryAddress",
              "create"
            ),
            onClick: async () => {
              this.$logger.trackEventButtonClickAddNew();

              if (this.baseView.mode == "edit") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes"
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewAddress();
                }
              } else {
                this.createNewAddress();
              }
            },
          },
        },
        searchPanel,
        exportButton
      );
    },
    createNewAddress() {
      this.model.CompanyName = "";
      this.model.PhysicalAddressCountry = "";
      this.model.Active = true;
      this.model.Note1 = "";
      this.model.Note2 = "";
      this.model.PhysicalAddressPostcode = "";
      this.model.RecordId = "00000000-0000-0000-0000-000000000000";
      this.model.DateChanged = "";
      this.model.DateCreated = "";
      this.model.ChangedBy = "";
      this.model.CreatedBy = "";
      this.model.LineNo = 0;
      this.model.PhysicalAddressState = "";
      this.model.PhysicalAddressStreetLine1 = "";
      this.model.PhysicalAddressStreetLine2 = "";
      this.model.PhysicalAddressSuburb = "";
      this.model.SelfReference = "";
      this.model.TransitDays = 0;
      this.model.DropCode = undefined;
      this.model.DeliveryInstructions = undefined;

      this.baseView.id = this.model.CustomerCode;
      this.$router.push({
        path: `/customer-delivery-address/create/${this.baseView.id}`,
      });
    },
    async handleLocalRouteChange() {
      this.formLoading = false;
      // let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.showLoading(true);
        this.model.RecordId = this.baseView.id;
        this.getRecord().then(async (response) => {
          if (response.data.value.length > 0) {
            this.model.PhysicalAddressCountry =
              response.data.value[0].PhysicalAddressCountry;
            this.model.SelfReference = response.data.value[0].SelfReference;

            this.model.CustomerCode = response.data.value[0].CustomerCode;
            this.model.CustomerName = response.data.value[0].Customer.Name;
            this.model.Active = response.data.value[0].Inactive == "N";
            this.model.Note1 = response.data.value[0].Note1;
            this.model.Note2 = response.data.value[0].Note2;
            this.model.PhysicalAddressPostcode =
              response.data.value[0].PhysicalAddressPostcode;
            this.model.RecordId = response.data.value[0].RecordId;
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.LineNo = response.data.value[0].LineNo;
            this.model.PhysicalAddressState =
              response.data.value[0].PhysicalAddressState;
            this.model.PhysicalAddressStreetLine1 =
              response.data.value[0].PhysicalAddressStreetLine1;
            this.model.CompanyName = response.data.value[0].CompanyName;
            this.model.PhysicalAddressStreetLine2 =
              response.data.value[0].PhysicalAddressStreetLine2;
            this.model.PhysicalAddressSuburb =
              response.data.value[0].PhysicalAddressSuburb;
            this.model.TransitDays = response.data.value[0].TransitDays;
            this.model.CustomerRegionCode = response.data.value[0].RegionCode;
            this.model.CustomerSubRegionCode =
              response.data.value[0].SubregionCode;
            this.model.DropCode = response.data.value[0].DropCode;
            this.model.DeliveryInstructions =
              response.data.value[0].DeliveryInstructions;
            // that.refreshView();
          }

          await this.getcusdetail(
            this.model.CustomerCode,
            response.data.value[0].Inactive,
            response.data.value[0]
          );

          this.formLoading = true;
          this.showLoading(false);
        });
      } else {
        await CustomerService.getByCode(this.baseView.id, [
          "Code",
          "Name",
          "MailAddressCompanyName",
          "MailAddressStreetLine1",
          "MailAddressStreetLine2",
          "MailAddressState",
          "MailAddressPostcode",
          "MailAddressCountry",
        ]).then((response) => {
          if (response.data.value.length > 0) {
            this.model.CustomerCode = response.data.value[0].Code;
            this.model.CustomerName = response.data.value[0].Name;
            this.CustomerDetails = response.data.value[0];
            // that.refreshView();
          }
        });

        await CustomerDropCodeService.getDefault({
          select: ["IsDefault", "Inactive", "Code"],
        }).then((res) => {
          if (res.data.value.length > 0)
            this.model.DropCode = res.data.value[0].Code;
        });

        await CustomerRegionService.getDefault({
          select: ["IsDefault", "Code"],
        }).then((res) => {
          if (res.data.value.length > 0)
            this.model.CustomerRegionCode = res.data.value[0].Code;
        });

        if (this.model.CustomerRegionCode) {
          await this.getDefaultSubRegion(this.model.CustomerRegionCode);
        }
        this.formLoading = true;
      }
    },
    async getRecord() {
      return CustomerDeliveryAddressService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/customer-delivery-address/review/${selectedRowsData[0].RecordId}`,
      });
      this.baseView.tempId = this.model.CustomerCode;
    },
    async changeDefaultAddress(record) {
      let confirmYes = await this.$confirm(
        "Do you wish to change the default address?",
        "Default Address"
      );

      if (confirmYes) {
        let that = this;

        // eslint-disable-next-line no-debugger
        await CustomerDeliveryAddressService.changeDefault({
          CustomerCode: record.CustomerCode,
          RecordId: record.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["deliveryAddressGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(
              error,
              "Customer Delivery Address set default failed"
            );
          });
      }
    },
    async deleteCustomerDeliveryAddress() {
      let that = this;

      let confirmLeaving = await this.$confirm(
        `Are you sure you want to delete ${this.model.CompanyName}?`,
        "Delete Address"
      );

      if (confirmLeaving) {
        this.showLoading(true);
        await CustomerDeliveryAddressService.delete({
          RecordId: this.model.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["deliveryAddressGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(
              error,
              "Customer Delivery Address delete failed"
            );
          });
      }
    },
    async saveCustomerDeliveryAddress(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.addErrorMessagesFromValidationResult(result);
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);

      if (
        this.model.CompanyName == "" &&
        this.model.PhysicalAddressStreetLine1 == "" &&
        (this.model.PhysicalAddressStreetLine2 == "") &
          (this.model.PhysicalAddressState == "") &&
        this.model.PhysicalAddressPostcode == "" &&
        this.model.PhysicalAddressCountry == ""
      ) {
        this.model.CompanyName = this.CustomerDetails.MailAddressCompanyName;
        this.model.PhysicalAddressStreetLine1 =
          this.CustomerDetails.MailAddressStreetLine1;
        this.model.PhysicalAddressStreetLine2 =
          this.CustomerDetails.MailAddressStreetLine2;
        this.model.PhysicalAddressState = this.CustomerDetails.MailAddressState;
        this.model.PhysicalAddressPostcode =
          this.CustomerDetails.MailAddressPostcode;
        this.model.PhysicalAddressCountry =
          this.CustomerDetails.MailAddressCountry;
      }

      await CustomerDeliveryAddressService.save(this.baseView.mode, {
        CompanyName: this.model.CompanyName,
        PhysicalAddressCountry: this.model.PhysicalAddressCountry,
        CustomerCode: this.model.CustomerCode,
        SelfReference: this.model.SelfReference,
        Inactive: this.model.Active ? "N" : "Y",
        Note1: this.model.Note1,
        Note2: this.model.Note2,
        PhysicalAddressPostcode: this.model.PhysicalAddressPostcode,
        RecordId: this.model.RecordId,
        LineNo: this.model.LineNo,
        PhysicalAddressState: this.model.PhysicalAddressState,
        PhysicalAddressStreetLine1: this.model.PhysicalAddressStreetLine1,
        PhysicalAddressStreetLine2: this.model.PhysicalAddressStreetLine2,
        PhysicalAddressSuburb: this.model.PhysicalAddressSuburb,
        TransitDays: this.model.TransitDays,
        RegionCode: this.model.CustomerRegionCode,
        SubregionCode: this.model.CustomerSubRegionCode,
        DropCode: this.model.DropCode,
        DeliveryInstructions: this.model.DeliveryInstructions
          ? this.model.DeliveryInstructions
          : "",
      })
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
            this.model.LineNo = res.data.LineNo;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveCustomerDeliveryAddress", res);
          this.$notify(
            `Customer Delivery Address ${this.model.CompanyName} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-delivery-address/review/${this.model.RecordId}`,
          });
          this.baseView.tempId = this.model.CustomerCode;
        })
        .catch((error) => {
          this.displayServerError(
            error,
            "Customer Delivery Address save failed"
          );
        });
    },
  },
};
</script>
